export default {
    list: {
        en: "Английский",
        it: "Итальянский",
        ru: "Русский",
        es: "Испанский",
    },
}
